export const getOtherUserInformation = (members, userId) => {
  const returnInfo = {};

  const bannerMessages = {
    closed: "This user can't be contacted because their Sittercity account is inactive.",
    frozen: "This user can't be contacted because their Sittercity account is inactive.",
    closed1: 'This user is no longer a member of the Sittercity network.',
    closed2: 'This user is no longer a member of the Sittercity network.',
    closed3: 'This user has been removed from the Sittercity network. Check your email for additional information.',
  };

  members.forEach((member) => {
    if (member.userId !== userId) {
      returnInfo.name = member.nickname;
      returnInfo.image = member.plainProfileUrl;
      returnInfo.account_status = member.metaData.account_status;
      returnInfo.correspondingUserAccountId = member.metaData.account_id;
      returnInfo.correspondingUserId = member.userId;
      returnInfo.providerType = member.metaData.provider_type || member.metaData.providerType;
      returnInfo.showMessageHistory = true;
      returnInfo.showTrustSafetyBanner = false;
      returnInfo.bannerMessage = '';
      returnInfo.showAvatar = true;
      returnInfo.showDate = true;
      returnInfo.accountClosed = false;

      if (
        member.metaData.account_status === 'closed1' ||
        member.metaData.account_status === 'closed2' ||
        member.metaData.account_status === 'closed3'
      ) {
        returnInfo.showMessageHistory = false;
        returnInfo.showAvatar = false;
      }

      if (
        member.metaData.account_status === 'closed1' ||
        member.metaData.account_status === 'closed2' ||
        member.metaData.account_status === 'closed3' ||
        member.metaData.account_status === 'closed' ||
        member.metaData.account_status === 'frozen'
      ) {
        returnInfo.showTrustSafetyBanner = true;
        returnInfo.bannerMessage = bannerMessages[returnInfo.account_status];
        returnInfo.showDate = false;
        returnInfo.accountClosed = true;
      }
    }
  });
  return returnInfo;
};

export default getOtherUserInformation;
